export const selectDisplayAnimationState = (state: RootState) =>
  state.virtualKoteach.display_animation_state;

export const selectDisplayAnimationFPS = (state: RootState) =>
  state.virtualKoteach.display_animation_fps;
